"use client";

import { usePathname } from "next/navigation";

import { cn } from "@/lib/utils";

/**
 * Gives each route one restrained entrance without introducing a layout box.
 * The pathname key intentionally excludes query-string changes: filtering and
 * pagination should update in place rather than replaying a page transition.
 */
export default function RouteStage({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  const pathname = usePathname();

  return (
    <div key={pathname} className={cn("route-stage contents", className)}>
      {children}
    </div>
  );
}
